import axiosInstance from '../../lib/api/axios';
import { Schema } from './types';
import { getServerUrl } from '../../lib/utils';

export const getSchema = async (id: number): Promise<Schema> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/schemas/${id}`);
  return data.schema;
};
